export const FLAG_GETTING_BUSES_BODY_WORKS = 'FLAG_GETTING_BUSES_BODY_WORKS';
export const GET_BUSES_BODY_WORKS = 'GET_BUSES_BODY_WORKS';
export const CLEAR_BUSES_BODY_WORKS = 'CLEAR_BUSES_BODY_WORKS';
export const FLAG_BUSES_BODY_WORKS_ACTIVITY = 'FLAG_BUSES_BODY_WORKS_ACTIVITY';
export const GET_BUS_BODY_WORK = 'GET_BUS_BODY_WORK';
export const CLEAR_BUS_BODY_WORK = 'CLEAR_BUS_BODY_WORK';
